import { useMemo } from "react";

import { useAppSelector } from "../../Store/Hooks";
import { selectPortfolioMapsConfig } from "../../Store/Reducers/VendorAdminSlice";
import {
  isPortfolioMapLensVisible,
  normalizePortfolioMapsConfig,
  type PortfolioMapsConfig,
} from "../../Utils/Constants/portfolioMapLenses";

/** Global Portfolio Maps visibility from Izba Admin → Config.
 * Fail-closed until settings resolve — avoids enabled→disabled layout flash. */
export function usePortfolioMapLenses(): {
  config: PortfolioMapsConfig;
  resolved: boolean;
  mapsEnabled: boolean;
  isLensVisible: (lensKey: string) => boolean;
} {
  const { resolved, raw } = useAppSelector(selectPortfolioMapsConfig);
  const config = useMemo(() => normalizePortfolioMapsConfig(raw), [raw]);

  return {
    config,
    resolved,
    // Until fetch completes, treat Maps as off (same pattern as org settings).
    mapsEnabled: resolved ? config.enabled : false,
    isLensVisible: (lensKey: string) =>
      resolved ? isPortfolioMapLensVisible(config, lensKey) : false,
  };
}
